

// import React, { useEffect, useMemo, useState } from "react";
// import { useNavigate, useParams, useLocation } from "react-router-dom";
// import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
// import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
// import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
// import Main from "../Main";
// import { AppBreadcrumbs } from "../../components/listing";
// import StatusBadge from "../../components/listing/StatusBadge";
// import { useBranding } from "../../context/BrandingContext";
// import { useNotify } from "../../context/NotifyContext";
// import { formatAmount } from "../../utils/formatAmount";
// import {
//   buildTxnDocument,
//   cacheTxnDetail,
//   downloadTxnPdf,
//   printTxnDocument,
//   readCachedTxnDetail,
// } from "../../utils/txnDocument";
// import { fetchRechargeById } from "../../api/rechages.Api";
// import blueLogo from "../../assests/newbrand/logo.webp";
// import { fetch_cc_payment_by_id } from "../../api/creditCardBillApi";

// /*
//  * Finkeda: user ko markup kabhi nahi dikhna chahiye, sirf final charge.
//  * - Backend charge me markup add karke bheje to markup field aayegi hi nahi
//  *   (markupAmount = 0) aur charge jaisa hai waisa dikhega.
//  * - Galti se markup / markupAmount aa jaye to yahan charge me add hoke dikhega.
//  * - markup / markupAmount / pricing row se hata diye jaate hain,
//  *   taaki view, print aur PDF kahin bhi markup na dikhe.
//  */
// const round2 = (x) => Math.round((Number(x) + Number.EPSILON) * 100) / 100;

// const getFinalCharge = (r) => {
//   const amount = Number(r?.amount) || 0;
//   const charge = Number(r?.charge) || 0;
//   const markupAmt =
//     r?.markupAmount != null
//       ? Number(r.markupAmount) || 0
//       : (amount * (Number(r?.markup) || 0)) / 100;
//   return round2(charge + markupAmt);
// };

// const sanitizeFinkedaRow = (r) => {
//   if (!r) return r;
//   // eslint-disable-next-line no-unused-vars
//   const { markup, markupAmount, pricing, ...rest } = r;
//   return { ...rest, charge: getFinalCharge(r) };
// };

// const HIDDEN_LABEL_RE = /markup/i;

// const TxnDetailPage = () => {
//   const { type = "recharge", id } = useParams();
//   const location = useLocation();
//   const navigate = useNavigate();
//   const { notify } = useNotify();
//   const { companyName, legalName, mediaUrl, settings } = useBranding();
//   const [row, setRow] = useState(location.state?.row || null);
//   const [loading, setLoading] = useState(!location.state?.row);

//   const brand = useMemo(() => {
//     const logoPath = settings?.logoLightUrl || settings?.logoDarkUrl;
//     return {
//       companyName,
//       legalName,
//       logoUrl: logoPath ? mediaUrl(logoPath) : blueLogo,
//     };
//   }, [companyName, legalName, mediaUrl, settings]);

//   useEffect(() => {
//     let cancelled = false;
//     const seed = location.state?.row;
//     const load = async () => {
//       if (seed) {
//         cacheTxnDetail(type, id, seed);
//         if (!cancelled) {
//           setRow(seed);
//           setLoading(false);
//         }
//         return;
//       }
//       const cached = readCachedTxnDetail(type, id);
//       if (cached) {
//         if (!cancelled) {
//           setRow(cached);
//           setLoading(false);
//         }
//         return;
//       }
//       alert("hiii")
//       if (type === "recharge" || type === "bbps") {
//         try {
//   const res = type === "bbps" ? await fetch_cc_payment_by_id(id) : await fetchRechargeById(id);
// console.log("DETAIL RES", res);
    
//           if (res?.success && (res?.data?.utilityPayment || res?.data?.recharge)) {
//             if (!cancelled) {
//               const rowData = res.data.utilityPayment || res.data.recharge;
//               setRow(rowData);
//               cacheTxnDetail(type, id, rowData);
//             }
//           } else if (!cancelled) {
//             notify(res?.message || "Transaction not found", "error");
//           }
//         } catch {
//           if (!cancelled) notify("Failed to load transaction", "error");
//         }
//       }
//       if (!cancelled) setLoading(false);
//     };
//     load();
//     return () => {
//       cancelled = true;
//     };
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [id, type]);

//   // Finkeda: markup strip + charge = final charge
//   const viewRow = useMemo(
//     () => (type === "finkeda" ? sanitizeFinkedaRow(row) : row),
//     [row, type]
//   );

//   const doc = useMemo(() => {
//     const d = buildTxnDocument(viewRow, type, brand);
//     if (!d || type !== "finkeda") return d;
//     // safety: agar txnDocument me koi markup wali line ho to hata do
//     return {
//       ...d,
//       fields: (d.fields || []).filter((f) => !HIDDEN_LABEL_RE.test(f.label)),
//     };
//   }, [viewRow, type, brand]);

//   const handlePrint = () => {
//     if (!doc) return;
//     const ok = printTxnDocument(doc);
//     if (!ok) notify("Please allow pop-ups to print", "warning");
//   };

//   const handlePdf = async () => {
//     if (!doc) return;
//     try {
//       await downloadTxnPdf(doc);
//       notify("PDF downloaded", "success");
//     } catch {
//       notify("PDF download failed", "error");
//     }
//   };

//   return (
//     <Main showRightPanel={false} showInfoText={false}>
//       <div className="mt-2">
//         <AppBreadcrumbs
//           items={[
//             { label: "Dashboard", to: "/" },
//             { label: "Transactions" },
//             { label: "Details" },
//           ]}
//         />

//         <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
//           <button
//             type="button"
//             className="ds-btn ds-btn-secondary ds-btn-sm"
//             onClick={() => navigate(-1)}
//           >
//             <ArrowBackOutlinedIcon sx={{ fontSize: 16 }} /> Back
//           </button>
//           <div className="flex gap-2">
//             <button
//               type="button"
//               className="ds-btn ds-btn-secondary ds-btn-sm"
//               onClick={handlePrint}
//               disabled={!doc}
//             >
//               <PrintOutlinedIcon sx={{ fontSize: 16 }} /> Print
//             </button>
//             <button
//               type="button"
//               className="ds-btn ds-btn-primary ds-btn-sm"
//               onClick={handlePdf}
//               disabled={!doc}
//             >
//               <PictureAsPdfOutlinedIcon sx={{ fontSize: 16 }} /> Download PDF
//             </button>
//           </div>
//         </div>

//         {loading ? (
//           <div className="ds-card text-[13px] text-[var(--text-muted)]">Loading details...</div>
//         ) : !doc ? (
//           <div className="ds-card text-[13px] text-[var(--text-muted)]">
//             Transaction details not available.
//           </div>
//         ) : (
//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
//             <div className="ds-card space-y-3">
//               <div className="flex items-start justify-between gap-3">
//                 <div>
//                   <p className="text-[12px] text-[var(--text-muted)] uppercase tracking-wide">
//                     {doc.subtitle}
//                   </p>
//                   <h1 className="text-[16px] font-semibold text-[var(--text-dark)] mt-0.5">
//                     {doc.companyName}
//                   </h1>
//                   {doc.legalName ? (
//                     <p className="text-[11px] text-[var(--text-muted)]">{doc.legalName}</p>
//                   ) : null}
//                 </div>
//                 {doc.logoUrl ? (
//                   <img
//                     src={doc.logoUrl}
//                     alt={doc.companyName}
//                     className="h-10 max-w-[120px] object-contain"
//                   />
//                 ) : null}
//               </div>

//               <div className="rounded-[3px] border border-[var(--border-color)] bg-[var(--bg-app)] p-3 text-center">
//                 <p className="text-[11px] text-[var(--text-muted)]">Amount</p>
//                 <p className="text-[22px] font-bold text-[var(--text-dark)]">
//                   ₹ {formatAmount(doc.amount)}
//                 </p>
//                 <div className="mt-2">
//                   <StatusBadge status={doc.status} />
//                 </div>
//               </div>
//             </div>

//             <div className="ds-card">
//               <h2 className="text-[14px] font-semibold text-[var(--text-dark)] mb-3">
//                 Transaction Details
//               </h2>
//               <div className="space-y-0">
//                 {doc.fields.map((f) => (
//                   <div
//                     key={f.label}
//                     className="flex justify-between gap-3 py-2 border-b border-[var(--border-color)] text-[12px] last:border-0"
//                   >
//                     <span className="text-[var(--text-muted)] font-medium">{f.label}</span>
//                     <span className="text-[var(--text-dark)] font-semibold text-right break-all">
//                       {f.value}
//                     </span>
//                   </div>
//                 ))}
//               </div>
//             </div>

//             {/* FinkedaPricingBreakdownBox hata diya: isme markup, hierarchy, extra
//                 sab dikhta hai, jo user ko nahi dikhna chahiye. */}
//           </div>
//         )}
//       </div>
//     </Main>
//   );
// };

// export default TxnDetailPage;



import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import Main from "../Main";
import { AppBreadcrumbs } from "../../components/listing";
import StatusBadge from "../../components/listing/StatusBadge";
import { useBranding } from "../../context/BrandingContext";
import { useNotify } from "../../context/NotifyContext";
import { formatAmount } from "../../utils/formatAmount";
import {
  buildTxnDocument,
  cacheTxnDetail,
  downloadTxnPdf,
  printTxnDocument,
  readCachedTxnDetail,
} from "../../utils/txnDocument";
import { fetchRechargeById } from "../../api/rechages.Api";
import { fetch_cc_payment_by_id } from "../../api/creditCardBillApi";
import blueLogo from "../../assests/newbrand/logo.webp";

/*
 * Finkeda: user ko markup kabhi nahi dikhna chahiye, sirf final charge.
 * markup / markupAmount / pricing row se hata diye jaate hain,
 * taaki view, print aur PDF kahin bhi markup na dikhe.
 */
const round2 = (x) => Math.round((Number(x) + Number.EPSILON) * 100) / 100;

const getFinalCharge = (r) => {
  const amount = Number(r?.amount) || 0;
  const charge = Number(r?.charge) || 0;
  const markupAmt =
    r?.markupAmount != null
      ? Number(r.markupAmount) || 0
      : (amount * (Number(r?.markup) || 0)) / 100;
  return round2(charge + markupAmt);
};

const sanitizeFinkedaRow = (r) => {
  if (!r) return r;
  // eslint-disable-next-line no-unused-vars
  const { markup, markupAmount, pricing, ...rest } = r;
  return { ...rest, charge: getFinalCharge(r) };
};

const HIDDEN_LABEL_RE = /markup/i;

// Credit card payment row (CreditCardBillPayment model) pehchanne ke liye
const isCcRow = (r) => !!r && (r.orderId || r.last4DigitCardNumber);

// bbps type par sirf credit card row valid maani jayegi (purani utilityPayment row nahi)
const isValidSeed = (type, r) => {
  if (!r) return false;
  if (type === "bbps") return !!isCcRow(r);
  return true;
};

const TxnDetailPage = () => {
  const { type = "recharge", id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { notify } = useNotify();
  const { companyName, legalName, mediaUrl, settings } = useBranding();

  const initialSeed = isValidSeed(type, location.state?.row) ? location.state.row : null;
  const [row, setRow] = useState(initialSeed);
  const [loading, setLoading] = useState(!initialSeed);

  const brand = useMemo(() => {
    const logoPath = settings?.logoLightUrl || settings?.logoDarkUrl;
    return {
      companyName,
      legalName,
      logoUrl: logoPath ? mediaUrl(logoPath) : blueLogo,
    };
  }, [companyName, legalName, mediaUrl, settings]);

  useEffect(() => {
    let cancelled = false;
    const seed = location.state?.row;

    const load = async () => {
      // 1) list se aayi row (bbps me sirf credit card row)
      if (isValidSeed(type, seed)) {
        cacheTxnDetail(type, id, seed);
        if (!cancelled) {
          setRow(seed);
          setLoading(false);
        }
        return;
      }

      // 2) cache (bbps me sirf credit card row)
      const cached = readCachedTxnDetail(type, id);
      if (isValidSeed(type, cached)) {
        if (!cancelled) {
          setRow(cached);
          setLoading(false);
        }
        return;
      }
      

      // 3) API
      if (type === "recharge" || type === "bbps") {
        try {
          const res =
            type === "bbps"
              ? await fetch_cc_payment_by_id(id)
              : await fetchRechargeById(id);

          const rowData = res?.data?.utilityPayment || res?.data?.recharge;

          if (res?.success && rowData) {
            if (!cancelled) {
              setRow(rowData);
              cacheTxnDetail(type, id, rowData);
            }
          } else if (!cancelled) {
            notify(res?.message || "Transaction not found", "error");
          }
        } catch {
          if (!cancelled) notify("Failed to load transaction", "error");
        }
      }
      if (!cancelled) setLoading(false);
    };

    load();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, type]);

  // Finkeda: markup strip + charge = final charge
  const viewRow = useMemo(
    () => (type === "finkeda" ? sanitizeFinkedaRow(row) : row),
    [row, type]
  );

  const doc = useMemo(() => {
    const d = buildTxnDocument(viewRow, type, brand);
    console.log("get the data",d)
    if (!d || type !== "finkeda") return d;
    return {
      ...d,
      fields: (d.fields || []).filter((f) => !HIDDEN_LABEL_RE.test(f.label)),
    };
  }, [viewRow, type, brand]);

  const handlePrint = () => {
    if (!doc) return;
    const ok = printTxnDocument(doc);
    if (!ok) notify("Please allow pop-ups to print", "warning");
  };

  const handlePdf = async () => {
    if (!doc) return;
    try {
      await downloadTxnPdf(doc);
      notify("PDF downloaded", "success");
    } catch {
      notify("PDF download failed", "error");
    }
  };

  return (
    <Main showRightPanel={false} showInfoText={false}>
      <div className="mt-2">
        <AppBreadcrumbs
          items={[
            { label: "Dashboard", to: "/" },
            { label: "Transactions" },
            { label: "Details" },
          ]}
        />

        <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
          <button
            type="button"
            className="ds-btn ds-btn-secondary ds-btn-sm"
            onClick={() => navigate(-1)}
          >
            <ArrowBackOutlinedIcon sx={{ fontSize: 16 }} /> Back
          </button>
          <div className="flex gap-2">
            <button
              type="button"
              className="ds-btn ds-btn-secondary ds-btn-sm"
              onClick={handlePrint}
              disabled={!doc}
            >
              <PrintOutlinedIcon sx={{ fontSize: 16 }} /> Print
            </button>
            <button
              type="button"
              className="ds-btn ds-btn-primary ds-btn-sm"
              onClick={handlePdf}
              disabled={!doc}
            >
              <PictureAsPdfOutlinedIcon sx={{ fontSize: 16 }} /> Download PDF
            </button>
          </div>
        </div>

        {loading ? (
          <div className="ds-card text-[13px] text-[var(--text-muted)]">Loading details...</div>
        ) : !doc ? (
          <div className="ds-card text-[13px] text-[var(--text-muted)]">
            Transaction details not available.
          </div>
        ) : (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            <div className="ds-card space-y-3">
              <div className="flex items-start justify-between gap-3">
                <div>
                  <p className="text-[12px] text-[var(--text-muted)] uppercase tracking-wide">
                    {doc.subtitle}
                  </p>
                  <h1 className="text-[16px] font-semibold text-[var(--text-dark)] mt-0.5">
                    {doc.companyName}
                  </h1>
                  {doc.legalName ? (
                    <p className="text-[11px] text-[var(--text-muted)]">{doc.legalName}</p>
                  ) : null}
                </div>
                {doc.logoUrl ? (
                  <img
                    src={doc.logoUrl}
                    alt={doc.companyName}
                    className="h-10 max-w-[120px] object-contain"
                  />
                ) : null}
              </div>

              <div className="rounded-[3px] border border-[var(--border-color)] bg-[var(--bg-app)] p-3 text-center">
                <p className="text-[11px] text-[var(--text-muted)]">Amount</p>
                <p className="text-[22px] font-bold text-[var(--text-dark)]">
                  ₹ {formatAmount(doc.amount)}
                </p>
                <div className="mt-2">
                  <StatusBadge status={doc.status} />
                </div>
              </div>
            </div>

            <div className="ds-card">
              <h2 className="text-[14px] font-semibold text-[var(--text-dark)] mb-3">
                Transaction Details
              </h2>
              <div className="space-y-0">
                {doc.fields.map((f) => (
                  <div
                    key={f.label}
                    className="flex justify-between gap-3 py-2 border-b border-[var(--border-color)] text-[12px] last:border-0"
                  >
                    <span className="text-[var(--text-muted)] font-medium">{f.label}</span>
                    <span className="text-[var(--text-dark)] font-semibold text-right break-all">
                      {f.value}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </Main>
  );
};

export default TxnDetailPage;